export default __webpack_public_path__ + "assets/insets13.png";